import Popup from '@/components/Common/DesignSystem/Popup/Popup';
import { GlobalStoreCtx } from '@/stores/GlobalStore';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';

const CartNotAvailablePopup: React.FC = () => {
  const { IsOpenCartNotAvailablePopup: isOpen, closeCartNotAvailablePopup: closePopup } = useContext(GlobalStoreCtx);

  return (
    <Popup isOpen={isOpen} mainBtn={{ label: '확인', onClick: closePopup }}>
      <>
        타사이트를 통해 진입하신 경우 <br />
        장바구니 사용이 제한됩니다.
      </>
    </Popup>
  );
};

export default observer(CartNotAvailablePopup);
